import { useState, useEffect } from "react";

const useRandomPattern = (id, oldPattern, enableShare) => {
  const [color, setColor] = useState("");
  const [randomIcon, setRandomIcon] = useState("");
  const [selectedPattern, setSelectedPattern] = useState("");

  useEffect(() => {
    const randomColor = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(
      Math.random() * 256
    )}, ${Math.floor(Math.random() * 256)}, ${Math.random().toFixed(1)})`;
    setColor(randomColor);

    const generateRandomPattern = () => {
      let pattern = "";
      const patternTypes = [
        "spiral",
        "radialBurst",
        "dotGrid",
        "scatteredShapes",
        "concentricCircles",
        "wave",
      ];
      const randomPattern =
        oldPattern !== null
          ? oldPattern
          : patternTypes[Math.floor(Math.random() * patternTypes.length)];
      setSelectedPattern(randomPattern);
      const centerX = 50;
      const centerY = 50;

      switch (randomPattern) {
        case "spiral":
          const numDots = Math.floor(Math.random() * 200) + 50;
          const spiralRadius = Math.floor(Math.random() * 50) + 30;
          const spacing = Math.random() * 10 + 3;

          for (let i = 0; i < numDots; i++) {
            const angle = (i * spacing * Math.PI) / 180;
            const radius = (spiralRadius * i) / numDots;
            const cx = centerX + radius * Math.cos(angle);
            const cy = centerY + radius * Math.sin(angle);
            const dotRadius = Math.random() * 3 + 1;
            const opacity = Math.random() * 0.5 + 0.5;

            pattern += `<circle cx="${cx}" cy="${cy}" r="${dotRadius}" fill="white" opacity="${opacity}" />`;
          }
          break;

        case "radialBurst":
          const numRays = Math.floor(Math.random() * 30) + 10;
          const maxRadius = 50;

          for (let i = 0; i < numRays; i++) {
            const angle = ((Math.PI * 2) / numRays) * i;
            const radius = Math.random() * maxRadius + 10;
            const x = centerX + radius * Math.cos(angle);
            const y = centerY + radius * Math.sin(angle);

            pattern += `<line x1="${centerX}" y1="${centerY}" x2="${x}" y2="${y}" stroke="white" stroke-width="${
              Math.random() * 2 + 1
            }" />`;
          }
          break;

        case "dotGrid":
          const numRows = Math.floor(Math.random() * 10) + 5;
          const numCols = Math.floor(Math.random() * 10) + 5;
          const spacingX = Math.random() * 10 + 10;
          const spacingY = Math.random() * 10 + 10;

          for (let i = 0; i < numRows; i++) {
            for (let j = 0; j < numCols; j++) {
              const cx = j * spacingX + 5;
              const cy = i * spacingY + 5;
              const radius = Math.random() * 3 + 2;

              pattern += `<circle cx="${cx}" cy="${cy}" r="${radius}" fill="white" />`;
            }
          }
          break;

        case "scatteredShapes":
          const numShapes = Math.floor(Math.random() * 50) + 20;

          for (let i = 0; i < numShapes; i++) {
            const shapeType = Math.floor(Math.random() * 3);
            const x = Math.random() * 100;
            const y = Math.random() * 100;
            const size = Math.random() * 10 + 5;

            switch (shapeType) {
              case 0:
                pattern += `<circle cx="${x}" cy="${y}" r="${
                  size / 2
                }" fill="white" />`;
                break;
              case 1:
                pattern += `<rect x="${x}" y="${y}" width="${size}" height="${size}" fill="white" />`;
                break;
              case 2:
                const x1 = x;
                const y1 = y - size / 2;
                const x2 = x - size / 2;
                const y2 = y + size / 2;
                const x3 = x + size / 2;
                const y3 = y + size / 2;
                pattern += `<polygon points="${x1},${y1} ${x2},${y2} ${x3},${y3}" fill="white" />`;
                break;
              default:
                break;
            }
          }
          break;

        case "concentricCircles":
          const numCircles = Math.floor(Math.random() * 10) + 5;
          const maxCircleRadius = 50;

          for (let i = 0; i < numCircles; i++) {
            const radius = (i + 1) * (maxCircleRadius / numCircles);
            pattern += `<circle cx="${centerX}" cy="${centerY}" r="${radius}" fill="none" stroke="white" stroke-width="${
              Math.random() * 2 + 1
            }" />`;
          }
          break;

        case "wave":
          const numWaves = Math.floor(Math.random() * 5) + 3;
          const amplitude = Math.random() * 20 + 10;
          const frequency = Math.random() * 0.05 + 0.05;

          for (let i = 0; i < numWaves; i++) {
            let wave = "";
            for (let x = 0; x <= 100; x += 1) {
              const y =
                50 +
                amplitude * Math.sin(frequency * x + (i * Math.PI) / numWaves);
              wave += `${x},${y} `;
            }
            pattern += `<polyline points="${wave}" fill="none" stroke="white" stroke-width="${
              Math.random() * 2 + 1
            }" />`;
          }
          break;

        default:
          const numStars = Math.floor(Math.random() * 50) + 20;

          for (let i = 0; i < numStars; i++) {
            const cx = Math.random() * 100;
            const cy = Math.random() * 100;
            const spikes = 5;
            const outerRadius = Math.random() * 5 + 2;
            const innerRadius = outerRadius / 2;
            let star = "";
            for (let j = 0; j < spikes; j++) {
              const angle = (Math.PI / spikes) * j * 2;
              const xOuter = cx + Math.cos(angle) * outerRadius;
              const yOuter = cy - Math.sin(angle) * outerRadius;
              const xInner =
                cx + Math.cos(angle + Math.PI / spikes) * innerRadius;
              const yInner =
                cy - Math.sin(angle + Math.PI / spikes) * innerRadius;
              star += `${xOuter},${yOuter} ${xInner},${yInner} `;
            }
            pattern += `<polygon points="${star}" fill="white" />`;
          }
          break;
      }
      return pattern;
    };

    setRandomIcon(generateRandomPattern());
  }, []);

  return { color, randomIcon, selectedPattern };
};

export default useRandomPattern;
